// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__3WbYI","errorLogs":"styles_errorLogs__1JkGe"};